module.exports = __webpack_public_path__ + "static/family-7eda0760b8d01ea5c7d5481c96dab6df.png";